module.exports = __webpack_public_path__ + "img/OriginalLogo.3d253fa5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/OriginalLogo.svg
// module id = ZJRZ
// module chunks = 0